// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2hRzj","buttons":"Footer_buttons__1zBUg"};